import type { CachedPiece } from './pieceCache';

export interface Viewport {
  width: number;
  height: number;
}

/**
 * Canvas 主渲染器。M1 仅负责清屏与绘制已缓存的碎片；
 * 主循环、按 zIndex 排序、特效等在 M2/M3 扩展。
 */
export class Renderer {
  constructor(private readonly ctx: CanvasRenderingContext2D) {}

  clear(viewport: Viewport, background: string): void {
    const { width, height } = viewport;
    this.ctx.fillStyle = background;
    this.ctx.fillRect(0, 0, width, height);
  }

  /** 在 (x,y) 绘制一块（x,y 为该块主体左上角的目标位置）。 */
  drawPiece(cached: CachedPiece, x: number, y: number, scale = 1): void {
    const { canvas, ox, oy } = cached;
    if (scale === 1) {
      this.ctx.drawImage(canvas, x - ox, y - oy);
    } else {
      const w = cached.width * scale;
      const h = cached.height * scale;
      this.ctx.drawImage(canvas, x - ox * scale, y - oy * scale, w, h);
    }
  }

  /** 绘制带旋转的块（M2 旋转模式用；M1 暂不用，先就位）。 */
  drawPieceRotated(cached: CachedPiece, x: number, y: number, deg: number, scale = 1): void {
    const { width, height } = cached;
    const cx = x - cached.ox * scale + (width * scale) / 2;
    const cy = y - cached.oy * scale + (height * scale) / 2;
    this.ctx.save();
    this.ctx.translate(cx, cy);
    this.ctx.rotate((deg * Math.PI) / 180);
    this.ctx.translate(-(width * scale) / 2, -(height * scale) / 2);
    this.ctx.drawImage(cached.canvas, 0, 0, width * scale, height * scale);
    this.ctx.restore();
  }
}
